// extracted by mini-css-extract-plugin
export default {"column":"SurveyQuestionTypePanel_column__bpo5G","questionType":"SurveyQuestionTypePanel_questionType__1Eddk","questionTypeIcon":"SurveyQuestionTypePanel_questionTypeIcon__2oYoa"};